import { requestApi } from 'api';
import { withDocument } from 'api/paths';
import Contact from 'features/addressBook/types/Contact';

export interface GetContactsParams {
  offset: number;
  limit: number;
  name?: string;
  companyName?: string;
  exactly?: boolean;
}

export interface GetContactsResponse {
  count: number;
  contacts: Array<Contact>;
}

export function getContacts(params: GetContactsParams) {
  return requestApi<GetContactsResponse>({
    url: withDocument('/address-book/contacts'),
    method: 'GET',
    credentials: true,
    params,
  }).then((response) => response.data);
}

export type CreateContactParams = Omit<Contact, 'id' | 'createdAt' | 'updatedAt'>;
export type CreateContactResponse = { id: string };

export function createContact(data: CreateContactParams) {
  return requestApi<CreateContactResponse>({
    url: withDocument('/address-book/contacts'),
    method: 'POST',
    credentials: true,
    data,
  }).then((response) => response.data);
}

export function getContactsById(id: string) {
  return requestApi<Contact>({
    url: withDocument(`/address-book/contacts/${id}`),
    method: 'GET',
    credentials: true,
  }).then((response) => response.data);
}

export type UpdateContactsByIdParams = Omit<Contact, 'createdAt' | 'updatedAt'>;
export type UpdateContactsByIdResponse = { id: string };

export function updateContactsById({ id, ...data }: UpdateContactsByIdParams) {
  return requestApi<UpdateContactsByIdResponse>({
    url: withDocument(`/address-book/contacts/${id}`),
    method: 'PUT',
    credentials: true,
    data,
  }).then((response) => response.data);
}

export function deleteContactsById(id: string) {
  return requestApi<unknown>({
    url: withDocument(`/address-book/contacts/${id}`),
    method: 'DELETE',
    credentials: true,
  }).then((response) => response.data);
}
